export const defaultState = () => ({
	taxonomies : {},
	config     : {
		hasMailPoet    : false,
		isWooActive    : null,
		isWooConnected : null,
		mailPoetLists  : [],
		mailPoetFields : [],
	},
	posts     : [],
	postTypes : [],
	campaigns : [],
	search    : '',
	wooKey    : {
		id          : '',
		description : '',
		truncated   : '',
		editUrl     : '',
	},
	error : false,
})
const state = defaultState()

export default state
